// extracted by mini-css-extract-plugin
export default {"subSection":"a0ovmX","withIcons":"b0ovmX","external":"c0ovmX","bigArrow":"d0ovmX"};